export enum ReportingDbType {
    ClickHouse = "ClickHouse",
    ClickHouseDr = "ClickHouseDr",
}

export const DbTypes = [
    {value: null, label: "No Preference"},
    {value: ReportingDbType.ClickHouse, label: ReportingDbType.ClickHouse},
    {value: ReportingDbType.ClickHouseDr, label: ReportingDbType.ClickHouseDr}
];
